"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtpChannelTypeToOtpHandlerContractsMap = exports.EOtpHandlerContracts = void 0;
const otp_settings_1 = require("../../otp-settings");
/**
 * Типы opt каналов микросервисов
 */
var EOtpHandlerContracts;
(function (EOtpHandlerContracts) {
    /**
     * otp-channel-standard
     */
    EOtpHandlerContracts["standard"] = "standard";
    /**
     * otp-channel-modileid
     */
    EOtpHandlerContracts["mobileid"] = "mobileid";
    // wapi = 'wapi', уже не используется
})(EOtpHandlerContracts || (exports.EOtpHandlerContracts = EOtpHandlerContracts = {}));
exports.OtpChannelTypeToOtpHandlerContractsMap = {
    [otp_settings_1.EOtpChannelTypes.sms]: EOtpHandlerContracts.standard,
    [otp_settings_1.EOtpChannelTypes.sim_push]: EOtpHandlerContracts.mobileid,
    [otp_settings_1.EOtpChannelTypes.viber]: EOtpHandlerContracts.standard,
    [otp_settings_1.EOtpChannelTypes.voice]: EOtpHandlerContracts.standard,
    [otp_settings_1.EOtpChannelTypes.vk]: EOtpHandlerContracts.standard,
    [otp_settings_1.EOtpChannelTypes.whatsapp]: EOtpHandlerContracts.standard,
    [otp_settings_1.EOtpChannelTypes.flashcall]: EOtpHandlerContracts.standard
};
//# sourceMappingURL=OtpHandlerContracts.enum.js.map